import type { To } from 'react-router';
import { CloseIcon } from '#assets/ReactSvg.ts';
import { IconLink } from '#components/atoms/link/icon-link/IconLink.tsx';
import { returnState, useAppLocation } from '#hooks/useAppLocation.ts';
import styles from './PageCloser.module.css';

type Props = {
  /** Fallback location in case there is no `from` in state */
  fallbackTo: To;
};

/**
 * This component should be used in "full page modals" like our create and edit pages.
 * It renders a link that attempts to return the user to where they were prior to opening
 * the page, and falls back to a provided `to`.
 *
 * It is not rendered in mobile views.
 */
export function PageCloser({ fallbackTo }: Props) {
  const location = useAppLocation();
  const from = location.state?.from;

  return (
    // returnState restores the origin page's own return chain, which a bare `to` would drop
    <IconLink className={styles.PageCloser} title="Close" to={from ?? fallbackTo} state={returnState(from)}>
      <CloseIcon />
    </IconLink>
  );
}
